import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import type { Notification } from '../../../core/models/notification.model';
import { RelativeTimePipe } from '../../pipes/relative-time.pipe';

// Único NotificationPanelComponent para dashboard.html y mensajes.html — hoy ese markup vive
// duplicado e inline en ambas páginas con contenido ligeramente distinto (parte_10 §6). El
// componente compartido asume la versión de _nav.js `renderHeader()` como fuente de verdad.
@Component({
  selector: 'app-notification-panel',
  standalone: true,
  imports: [RelativeTimePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './notification-panel.component.html',
})
export class NotificationPanelComponent {
  readonly notifications = input<Notification[]>([]);
  readonly itemClick = output<Notification>();

  readonly unreadCount = computed(() => this.notifications().filter((n) => !n.is_read).length);
}
